import { getBrowserTimeZone } from '@atlassian/jira-platform-utils-datetime/src/index.tsx';
import { useUserSubscriber } from '@atlassian/jira-user-services/src/main.tsx';

export function useUserTimezone() {
	const [{ data: loggedInUser }] = useUserSubscriber();
	const loggedInUserTimeZone = loggedInUser ? loggedInUser.timeZone : undefined;
	const userTimeZone = loggedInUserTimeZone || getBrowserTimeZone();
	return { userTimeZone };
}
